import {SET_PAGE} from "./types";

export const setPage = payload => ({
    type: SET_PAGE,
    payload
});